module.exports = __webpack_public_path__ + "static/media/x.7d05d03c.svg";